import React, { useContext, useState } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import bytesToDisplayHelper from "../../../../utils/bytesToDisplayHelper.js";
import { CircularProgressbar } from "react-circular-progressbar";
import { useUploader } from "../../../../contexts/uploaderContext/uploaderContext.js";
import { useUploadingSpeed } from "../Helpers/useUploadingSpeed.js";
import { UploaderContext } from "../UploaderComponent/HomeUploader.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import SimpleUploadModal from "../Modals/SimpleUploadModal.js";
import { useCookie } from "contexts/cookieContext/cookieContext.js";

const UploadProgressComponent = () => {
  const {
    uploaderPauseAll,
    uploaderGetFiles,
    uploaderResumeAll,
    getSize,
    getUploading,
    getIsUppy,
  } = useUploader();

  const { getTextByKey } = useContent();

  const { setModal } = useModal();

  const { getCookie, setCookies } = useCookie();

  const [paused, setPaused] = useState(false);

  const data = uploaderGetFiles();

  const viewSize = bytesToDisplayHelper(getSize());

  const { uploadCounter, filesProgress } = useContext(UploaderContext);

  const { estimationTime, progress, getuploadedSize, uploadSpeed } =
    useUploadingSpeed(filesProgress);

  const uploadedSize = bytesToDisplayHelper(getuploadedSize());

  const hanldePause = () => {
    if (!getIsUppy()) return;
    if (getUploading() && getuploadedSize() > 0) {
      if (!paused) {
        uploaderPauseAll();
        setPaused(true);
        if (getCookie("uploading-paused-modal-was-shown") !== "true") {
          setModal({
            modal: SimpleUploadModal,
            props: {
              image: {
                name: "home/uploading-pause",
                ext: "png",
                className: "home-uploading-paused",
              },
              text: "uploading-paused-text",
              subText: "uploading-paused-sub-text",
            },
          });
          setCookies("uploading-paused-modal-was-shown", true);
        }
      } else {
        uploaderResumeAll();
        setPaused(false);
      }
    }
  };

  const uploadingString = () => {
    return (
      <>
        {`${getTextByKey("uploading-text")} ${uploadCounter}/${data.length} `}
        <span>
          {`(${uploadedSize.size} ${uploadedSize.type} / ${viewSize.size} ${viewSize.type})`}
        </span>
      </>
    );
  };

  const progressCircle = progress > 97 && progress < 100 ? 97 : progress;

  return getUploading() ? (
    <>
      <div className="desktop-total-progress-wrapper">
        <div className="total-progress" onClick={hanldePause}>
          {getUploading() && getuploadedSize() > 0 && getIsUppy() ? (
            <div className="upload-status-handler">
              <Icon name={!paused ? "pause_icon" : "play"} darkGray />
            </div>
          ) : null}
          <CircularProgressbar
            value={progressCircle || "1"}
            text={(progress || "0") + "%"}
            strokeWidth={8}
            className={paused ? "paused" : ""}
          />
        </div>
      </div>
      <div className="uploading-info">
        <div className="counter-files-size">
          {getUploading() ? uploadingString() : null}
        </div>
        <div className="estimation-time">
          {estimationTime.length > 0
            ? `${uploadSpeed}/s ${getTextByKey(
                "estimation-time-text"
              )} ${estimationTime}`
            : ""}
        </div>
      </div>
    </>
  ) : (
    false
  );
};

export default UploadProgressComponent;
